import { defaultDirection } from '../constants/defaultValues';

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    var A = a[key],
      B = b[key];
    if (order.indexOf(A + '') > order.indexOf(B + '')) {
      return 1;
    } else {
      return -1;
    }
  });
  return array;
};

export function mergeDeep(...objects) {
  const isObject = obj => obj && typeof obj === 'object';

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key];
      const oVal = obj[key];

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal);
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = mergeDeep(pVal, oVal);
      } else {
        prev[key] = oVal;
      }
    });

    return prev;
  }, {});
}

export const getDateWithFormat = () => {
  const today = new Date();
  let dd = today.getDate();
  let mm = today.getMonth() + 1; //January is 0!

  var yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }
  return dd + '.' + mm + '.' + yyyy;
};

export const getCurrentTime = () => {
  const now = new Date();
  return now.getHours() + ':' + now.getMinutes();
};

export const getDirection = () => {
  let direction = defaultDirection;
  if (localStorage.getItem('direction')) {
    const localValue = localStorage.getItem('direction');
    if (localValue === 'rtl' || localValue === 'ltr') {
      direction = localValue;
    }
  }
  return {
    direction,
    isRtl: direction === 'rtl',
  };
};

export const setDirection = localValue => {
  let direction = 'ltr';
  if (localValue === 'rtl' || localValue === 'ltr') {
    direction = localValue;
  }
  localStorage.setItem('direction', direction);
};
export const isArray = array => array instanceof Array;

export const isNull = value =>
  value === null || value === undefined || value === 'null';

export const isObjectEmpty = object => {
  return Object.keys(object).length === 0;
};

export const isAdmin = value => ['ADMIN', 'SUPER_ADMIN'].includes(value);

export const isUser = value => ['BASIC', 'SUPER_ADMIN'].includes(value);

export const isLawyer = value => ['LAWYER', 'SUPER_ADMIN'].includes(value);

export const isMaster = value => 'MASTER' === value;

export const generatePath = (path, params = {}) => {
  const asArrayParams = Object.entries(params);
  const filteredArrayParams = asArrayParams.filter(([key, value]) =>
    Boolean(value)
  );
  const filteredParams = Object.fromEntries(filteredArrayParams);
  const queryParams = new URLSearchParams(filteredParams);
  const queryString = queryParams.toString();

  return `${path}${queryString !== '' ? `?${queryString}` : ''}`;
};

export const generateUrl = (base, path, params = {}) => {
  return `${base}${generatePath(path, params)}`;
};

export const parseUrlWithPayload = (url, payload) => {
  const searchParams = new URLSearchParams();
  for (var [key, value] of Object.entries(payload)) {
    if (
      value !== null &&
      value !== 'null' &&
      value !== undefined &&
      value !== 'undefined'
    )
      searchParams.set(key, value);
  }

  return searchParams.toString() !== ''
    ? `${url}?${searchParams.toString()}`
    : url;
};

export function windowOpenDocument(url, isNewTab = true) {
  const viewportwidth = document.documentElement.clientWidth;
  const viewportheight = document.documentElement.clientHeight;
  const randomnumber = Math.floor(Math.random() * 100 + 1);
  window.open(
    `/viewer?url=${encodeURIComponent(url)}`,
    `PopUp-${randomnumber}`,
    isNewTab
      ? null
      : `width=800,height=600,top=${viewportheight - 50},left=${
          viewportwidth - 50
        }`
    // 'toolbar=yes,titlebar=yes,status=yes,menubar=yes,fullscreen=yes,centerscreen=yes'
  );
}

export function windowOpenDocumentById(id, isNewTab = true) {
  const viewportwidth = document.documentElement.clientWidth;
  const viewportheight = document.documentElement.clientHeight;
  const randomnumber = Math.floor(Math.random() * 100 + 1);
  window.open(
    `/viewer?id=${id}`,
    `PopUp-${randomnumber}`,
    isNewTab
      ? null
      : `width=800,height=600,top=${viewportheight - 50},left=${
          viewportwidth - 50
        }`
    // 'toolbar=yes,titlebar=yes,status=yes,menubar=yes,fullscreen=yes,centerscreen=yes'
  );
}

export function windowOpenVideo(url) {
  const viewportwidth = document.documentElement.clientWidth;
  const viewportheight = document.documentElement.clientHeight;
  const randomnumber = Math.floor(Math.random() * 100 + 1);
  window.open(
    `/player?url=${url}`,
    `PopUp-${randomnumber}`,
    `width=640,height=360,top=${viewportheight - 50},left=${viewportwidth - 50}`
  );
}

export const camalize = value => {
  value = value.toLowerCase();
  return value[0].charAt(0).toUpperCase() + value.slice(1);
};

export const firstNameAndLastNameParser = (fullName, excludes = []) => {
  let fullNameParse = fullName.toLowerCase();

  for (var exclude of excludes) {
    fullNameParse = fullNameParse.replace(exclude, '');
  }

  const split = fullNameParse.trim().split(' ');
  const firstName = split[0].charAt(0).toUpperCase() + split[0].slice(1);
  const lasName =
    split[split.length - 1].charAt(0).toUpperCase() +
    split[split.length - 1].slice(1);
  return `${firstName} ${lasName}`;
};

export const getWhitelabelName = pathname => {
  if (pathname.includes('scn')) {
    return 'scn';
  }

  return 'default';
};

export const getSmallNumber = value => {
  if (value >= 99) {
    return '99+';
  }

  if (value <= 0) {
    return undefined;
  }

  return value;
};

export const randomNumber = (min, max) => {
  return Math.floor(Math.random() * (max - min) + min);
};

export const removeUndefinedValuesFromObject = obj => {
  Object.keys(obj).forEach(key => obj[key] === undefined && delete obj[key]);
  return obj;
};

export const removeEmptyValuesFromArray = arr => {
  return arr?.reduce((acc, curr) => {
    if (curr != null && curr !== undefined && curr !== '') {
      acc.push(curr);
    }

    return acc;
  }, []);
};

export const removeSpecialCharacteres = value =>
  value.replace(/[^a-zA-Z0-9 ]/, '');

export const getNumberFromCurrency = currency => {
  return Number(currency.replace(/[$.]/g, '').replace(',', '.'));
};

export const sleep = (ms: number) => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const parseSubject = subject => {
  const subejects = subject
    ?.split(/[-|></]/)
    .map((item: string) => item.replace(/[(\d)]/g, '').trim());

  return removeEmptyValuesFromArray(subejects);
};
